import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Select, Input, Autocomplete, Hidden } from '~/components/Form';

import { GFO, GPPEM, GFE, GPP, GPPE } from '~/constants/perfil';


import * as S from './styles';

import { toast } from 'react-toastify';

import qs from 'querystring';

import * as Yup from 'yup';

import {
  t,
  validCharacters,
  validCharactersComAcentuados,
  validarCPF,
} from '~/helpers';

import { isEmpty, isArray, isUndefined, remove } from 'lodash';

import api from '~/services/api';

//export default function DadosUsuario({ data, onHandleBuscaUnidadeOrgao, onHandleBuscaPostosGPPEM, onHandleAtualizaTabs, onHandleAtualizaPerfCodigo }) {
export default function DadosUsuario({
  data,
  onHandleBuscaPostosGPPEM,
  onHandleAtualizaTabs,
  onHandleAtualizaPerfCodigo,
}) {
  //const DadosUsuario = React.memo((data) => {

  const { profile } = useSelector((state) => state.user);

  const [habilitaCampoEmail, setHabilitaCampoEmail] = React.useState(false);

  const [habilitaCampoOrgao, setHabilitaCampoOrgao] = React.useState(false);
  const [habilitaCampoPosto, setHabilitaCampoPosto] = React.useState(false);
  const [
    habilitaCampoControlaAgenda,
    setHabilitaCampoControlaAgenda,
  ] = React.useState(false);
  const [
    habilitaCampoAprovaPreFatura,
    setHabilitaCampoAprovaPreFatura,
  ] = React.useState(false);
  const [usua_recebe_email, setUsua_recebe_email] = useState('');
  const [usua_email, setUsua_email] = useState('');
  const [perf_tipo, setPerf_tipo] = useState(undefined);

  const [perf_codigo, setPerf_codigo] = useState(undefined);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isEmpty(data)) {
    }
  }, [data]);

  const [valuePosto, setValuePosto] = React.useState(0);
  const [inputValuePosto, setInputValuePosto] = React.useState('');

  const [valueOrgao, setValueOrgao] = React.useState(0);
  const [inputValueOrgao, setInputValueOrgao] = React.useState('');

  const [valuePerfil, setValuePerfil] = React.useState(0);
  const [inputValuePerfil, setInputValuePerfil] = React.useState('');

  const submitHandler = (event) => {
    //event.preventDefault();
    //data.onAddIngredient({ title: enteredTitle, amount: enteredAmount });
  };

  const listaNivelAcessoPesquisa = [
    { value: '1', label: 'Gestor Sistema' },
    { value: '2', label: 'Gestor de Frota do Estado' },
    { value: '3', label: 'Gestor de Frota do Órgão' },
    { value: '4', label: 'Gestor de Frota da Unidade' },
    { value: '5', label: 'Gestor de Posto do Órgão' },
    { value: '6', label: 'Gestor de Posto' },
    // { value: '7', label: 'Frentista' },
    { value: '8', label: 'Gestor de Posto Próprio Multi Posto' },
    { value: '62', label: 'Atendimento CallCent' },
    { value: '64', label: 'Service Desk' },
    { value: '65', label: 'Manutenção Abastek' },
    { value: '66', label: 'Consulta Operação' },
    { value: '67', label: 'Gestor de Frota do Estado - Consulta' },
    { value: '68', label: 'Gestor de Frota do Órgão - Consulta' },
    { value: '69', label: 'Gestor de Frota da Unidade - Consulta' },
    { value: '70', label: 'Gestor de Posto do Órgão - Consulta' },
    { value: '71', label: 'Gestor de Posto - Consulta' },
    // { value: '72', label: 'Frentista - Consulta' },
    { value: '73', label: 'Gestão OS Veículos' },
    { value: '75', label: 'Consulta Abastecimen' },
    { value: '76', label: 'Gestor Abastek Comercial' },
    { value: '77', label: 'Gestor Abastek Financeiro' },
  ];

  const listaPerfilcessoPesquisa = useMemo(() => {

    let tempArrayPerfil = [
      { value: 1, label: 'Gestor Sistema' },
      { value: 2, label: 'Gestor de Frota do Estado' },
      { value: 3, label: 'Gestor de Frota do Órgão' },
      { value: 4, label: 'Gestor de Frota da Unidade' },
      { value: 5, label: 'Gestor de Posto do Órgão' },
      { value: 6, label: 'Gestor de Posto' },
      // { value: '7', label: 'Frentista' },
      { value: 8, label: 'Gestor de Posto Próprio Multi Posto' },
    ];
    if (profile.gloperfilid == GFE) {
      tempArrayPerfil = remove(tempArrayPerfil, (item) => {
        return item.value != 1 && item.value != 2
      })

    } else if (profile.gloperfilid == GPPEM || profile.gloperfilid == GPPE) {
      tempArrayPerfil = remove(tempArrayPerfil, (item) => {
        return item.value == 6
      })
    }
    // else if (profile.gloperfilid == GPPE) {
    //   tempArrayPerfil = remove(tempArrayPerfil, (item) => {
    //     return item.value == 6 || item.value == 8 || item.value == 71
    //   })
    // }

    return tempArrayPerfil;


  }, [profile])

  const HandleBuscaUnidadeOrgao = useCallback(
    async (orga_codigo) => {
      try {
        setLoading(true);

        //Busca Unidade geral
        let params = {};
        switch (profile.glousuariotipo) {
          case GFO:
            params = {
              fieldlist: 'unid_nome, unid_codigo ',
              wherefield: ['orga_codigo'],
              typewherefield: ['EQUALS'],
              valuewherefield: [profile.glousuarioorgacodigo],
              orderfield: 'unid_codigo',
              pagesize: 99999,
            };
            break;
          default:
            params = {
              fieldlist: 'unid_nome, unid_codigo, orga_codigo ',
              wherefield: ['orga_codigo'],
              typewherefield: ['EQUALS'],
              valuewherefield: [orga_codigo],
              orderfield: 'unid_codigo',
              pagesize: 99999,
            };
        }
        const responseUnidades = await api.get('unidades', {
          params,
          paramsSerializer: (param) => qs.stringify(param),
        });
        let dadosUnidades = responseUnidades.data.items;

        data.orga_codigo = orga_codigo;
        data.rowsDisponiveis = dadosUnidades;
        data.rowsSelecionadas = [];

        // const objSend = {
        //   ...data,
        //   orga_codigo: orga_codigo,
        //   //dadosUnidades: dadosUnidades,
        //   rowsDisponiveis: dadosUnidades,
        //   rowsSelecionadas: [],
        // };
        // setData(objSend);
      } catch (err) {
        if (isArray(err)) err.map((e) => toast.error(t(e)));
        else toast.error(t(err));
      } finally {
        setLoading(false);
      }
    },
    [data]
  );

  useEffect(() => {
    if (!isEmpty(usua_recebe_email)) handleControlEnviaEmail(usua_recebe_email);
  }, [usua_recebe_email]);

  function handleControlEnviaEmail(value) {
    if (value === 'S') {
      setHabilitaCampoEmail(true);
    } else {
      setHabilitaCampoEmail(false);
    }
  }

  useEffect(() => {
    if (!isUndefined(perf_tipo)) {
      handleControlNivelAcesso(perf_tipo);
    }
  }, [perf_tipo, data]);

  useEffect(() => {
    if (!isUndefined(perf_codigo)) {
      if (data.perf_codigo !== perf_codigo) {
        onHandleAtualizaPerfCodigo(perf_codigo);
      }
      //data.perf_codigo = perf_codigo;
    }
  }, [perf_codigo, data]);



  async function handleControlNivelAcesso(value) {
    await onHandleAtualizaTabs(data.perf_tipo);

    if (value !== '4') {
      await setHabilitaCampoControlaAgenda(false);
    } else if (value === '4') {
      if (String(valuePerfil) === '69') {
        await setHabilitaCampoControlaAgenda(true);
      } else {
        await setHabilitaCampoControlaAgenda(false);
      }
    }

    if (value !== '3') {
      await setHabilitaCampoAprovaPreFatura(false);
    } else if (value === '3') {
      if (String(valuePerfil) === '3') {
        await setHabilitaCampoAprovaPreFatura(true);
      } else {
        await setHabilitaCampoAprovaPreFatura(false);
      }
    }

    if (String(value) === '3' || String(value) === '4') {
      await setHabilitaCampoOrgao(true);
    }

    if (String(value) === '6' || String(value) === '7') {
      await setHabilitaCampoPosto(true);
    }

    if (String(value) !== '3' && String(value) !== '4') {
      await setValueOrgao('');
      await setInputValueOrgao('');
      await setHabilitaCampoOrgao(false);
    }

    if (String(value) !== '6') {
      await setValuePosto('');
      await setInputValuePosto('');
      await setHabilitaCampoPosto(false);
    }
  }

  const handleControlOrgaCodigo = useCallback(
    async (value) => {
      if (data.orga_codigo !== value) await HandleBuscaUnidadeOrgao(value);
      //await onHandleBuscaUnidadeOrgao(value);

      const obj = {
        orga_codigo: value,
        perf_tipo: data.perf_tipo,
      };

      if (value !== null) {
        if (String(data.perf_tipo) === '3' || String(data.perf_tipo) === '4') {
          await setValueOrgao(value);
        } else {
          await setValueOrgao('');
          await setInputValueOrgao('');
        }
      } else {
        await setValueOrgao(0);
      }
    },
    [data]
  );

  async function handleControlPocoCodigo(value) {
    data.poco_codigo = value;
    if (value !== null) {
      await setValuePosto(value);
    } else {
      await setValuePosto(0);
    }
  }

  async function handleControlPerfCodigo(value) {
    //data.perf_codigo = value;
    if (value !== null && value !== undefined) {
      await setValuePerfil(value);
      if (String(value) === '69') {
        await setHabilitaCampoControlaAgenda(true);
      } else {
        await setHabilitaCampoControlaAgenda(false);
      }
      if ((String(value) === '3') || (String(value) === '2')) {
        await setHabilitaCampoAprovaPreFatura(true);
      } else {
        await setHabilitaCampoAprovaPreFatura(false);
      }
    } else {
      await setValuePerfil(0);
      await setHabilitaCampoControlaAgenda(false);
      await setHabilitaCampoAprovaPreFatura(false);
    }
  }

  async function handleControlUsua_consulta_controla_agenda(value) {
    data.usua_consulta_controla_agenda = value;
  }

  async function handleControlUsua_aprova_pre_faturamento(value) {
    data.usua_aprova_pre_faturamento = value;
  }

  // async function valideUsuaLogin(value) {
  //   let login = value.target.value;
  //   //Dados do Usuario
  //   const response = await api.get(`usuariomaster/${login}`);
  //   let dadosUsuario = response.data;
  //   if (!isEmpty(dadosUsuario.usua_login)) {
  //     toast.error('O login já está cadastrado!');
  //   }
  //   data.usua_login = undefined;
  //   //console.log( dadosUsuario );
  // }


  return (
    <S.Conteiner>
      <Input
        required
        disabled={data && data.operacao === 'ALTERACAO' ? true : false}
        name="usua_login"
        label="Login"
        getValue={
          (value) => (data.usua_login = value)
        }
      // onBlur={ valideUsuaLogin  }
      />

      <Input
        required
        name="usua_nome"
        label="Nome"
        getValue={(value) => (data.usua_nome = value)}
      />

      <Input
        required
        name="usua_cpf"
        label="CPF"
        getValue={(value) => (data.usua_cpf = value)}
      />

      <Select
        required
        name="usua_recebe_email"
        label="Envia Email?"
        getValue={(value) => {
          data.usua_recebe_email = value;
          setUsua_recebe_email(value);
        }}
        options={[
          { value: 'S', label: 'sim' },
          { value: 'N', label: 'não' },
        ]}
      />

      <Input
        name="usua_email"
        label="Email"
        getValue={(value) => {
          data.usua_email = value;
          setUsua_email(value);
        }}
        disabled={!habilitaCampoEmail}
      />

      <Input
        required
        name="usua_senha"
        label="Senha Terminal"
        type="password"
        getValue={(value) => (data.usua_senha = value)}
      />

      {profile.glousuariotipo === GFO && (
        <Input
          name="perf_tipo"
          value={'Gestor de Frota da Unidade'}
          label="Nível de Acesso"
          disabled
        />
      )}

      {profile.glousuariotipo !== GFO && (
        <Select
          required
          name="perf_tipo"
          label="Nível de Acesso"
          getValue={(value) => {

            if (!isUndefined(value)) {
              if (data.perf_tipo !== value) {
                data.perf_codigo = null;
                setValuePerfil(null);
                data.orga_codigo = '';
                data.rowsDisponiveis = [];
                data.rowsSelecionadas = [];
              }
              setPerf_tipo(value);
              data.perf_tipo = value;
            }
          }}
          options={listaPerfilcessoPesquisa}
        />
      )}

      {profile.glousuariotipo === GFO && (
        <>
          <Input
            name="orga_nome"
            value={profile.glousuarioorganome}
            label="Órgão"
            disabled
          />

          <Hidden
            name="orga_codigo"
            value={profile.glousuarioorgacodigo}
            label="Órgão"
            disabled
          />
        </>
      )}

      {profile.glousuariotipo !== GFO && habilitaCampoOrgao && (
        <Autocomplete
          name="orga_codigo"
          label="orga_nome"
          title="Órgão"
          id="orga_codigo"
          url="orgaos"
          unique="orga_codigo"
          disabled={
            String(data.perf_tipo) === '3'
              ? false
              : String(data.perf_tipo) === '4'
                ? false
                : true
          }
          hiddens={[{ name: 'orga_nome' }]}
          getValue={(value) => {
            if (data.orga_codigo !== value.orga_codigo) {
              handleControlOrgaCodigo(value.orga_codigo);
            }
          }}
        />
      )}

      {habilitaCampoPosto &&

        <>
          {
            profile.glousuariotipo === GPPEM ? (

              <Autocomplete
                name="poco_codigo"
                label="poco_desc_abrev"
                title="Posto"
                id="poco_codigo"
                url="postoscomboios/postosusuario"
                unique="poco_codigo"
                disabled={String(data.perf_tipo) === '6' ? false : true}
                defaultValue=""
                hiddens={[{ name: 'poco_desc_abrev' }]}
                getValue={(value) => {
                  handleControlPocoCodigo(value.poco_codigo);
                }}

                params={{
                  wherefield: 'usua_login',
                  valuewherefield: profile.id,
                  typewherefield: 'EQUALS',
                }}


              />) :


              <Autocomplete
                name="poco_codigo"
                label="poco_desc_abrev"
                title="Posto"
                id="poco_codigo"
                url="postoscofing"
                unique="poco_codigo"
                disabled={String(data.perf_tipo) === '6' ? false : true}
                defaultValue=""
                hiddens={[{ name: 'poco_desc_abrev' }]}
                getValue={(value) => {
                  handleControlPocoCodigo(value.poco_codigo);
                }}

              />
          }
        </>
      }

      <Autocomplete
        name="perf_codigo"
        label="perf_descricao"
        title="Perfil"
        //id="perf_codigo"
        url="perfil"
        unique="perf_codigo"
        disabled={
          profile.glousuariotipo === GFO
            ? false
            :
            data.perf_tipo !== undefined
              ? false
              : true
        }
        //value={valuePerfil}
        //inputValue={inputValuePerfil}
        // onChange={(event, newValue) => {
        //   setValuePerfil(newValue);
        // }}
        // onInputChange={(event, newInputValuePosto) => {
        //   setInputValuePerfil(newInputValuePosto);
        // }}
        hiddens={[{ name: 'perf_descricao' }]}
        getValue={(value) => {
          if (!isUndefined(value)) {
            setPerf_codigo(value.perf_codigo);

            if (value) {
              //data.perf_codigo = value.perf_codigo;
              handleControlPerfCodigo(value.perf_codigo);
            } else {
              data.perf_codigo = value;
              handleControlPerfCodigo(value);
            }
          } else {
            setPerf_codigo(0);
          }
        }}
        params={{
          wherefield: 'PERF_TIPO',
          //valuewherefield: profile.glousuariotipo === GFO ? '4' : perf_tipo,
          valuewherefield:
            profile.glousuariotipo === GFO ? '4' : data.perf_tipo,
          typewherefield: 'EQUALS',
        }}
      />

      <Select
        required
        name="usua_status"
        label="Status"
        options={[
          { value: '1', label: 'Liberado' },
          { value: '2', label: 'Bloqueado' },
          { value: '3', label: 'Cancelado' },
        ]}
        getValue={(value) => (data.usua_status = value)}
      />

      {habilitaCampoControlaAgenda && (
        <Select
          name="usua_consulta_controla_agenda"
          label="Controla Agenda"
          options={[
            { value: '', label: '' },
            { value: '1', label: 'sim' },
            { value: '0', label: 'nao' },
          ]}
          getValue={(value) => (data.usua_consulta_controla_agenda = value)}
        />
      )}

      {habilitaCampoAprovaPreFatura && (
        <Select
          name="usua_aprova_pre_faturamento"
          label="Aprova Faturamento"
          options={[
            { value: '', label: '' },
            { value: 'S', label: 'sim' },
            { value: 'N', label: 'nao' },
          ]}
          getValue={(value) => (data.usua_aprova_pre_faturamento = value)}
        />
      )}
    </S.Conteiner>
  );
}
